import type { LocationData } from "./LocationPage";

export const LOCATIONS: LocationData[] = [
  {
    slug: "elektriker-koebenhavn",
    city: "København",
    heroVariant: "stats",
    responseMinutes: 60,
    vibe: "København er vores hjemmebane. Vi har biler i alle bydele hver eneste hverdag og kender byens ejendomme, ejerforeninger og erhverv ud og ind, fra ældre brokvarterer til nybyggeri i Nordhavn og Ørestad.",
    housing: "Byens boligmasse spænder bredt: klassiske karréejendomme fra slutningen af 1800-tallet, funkis og mellemkrigstid, betonbyggeri fra 60'erne og 70'erne, og store mængder moderne nybyg i havneområderne.",
    neighborhoods: ["Indre By", "Østerbro", "Nørrebro", "Vesterbro", "Frederiksberg", "Amager", "Nordhavn", "Sydhavn", "Valby", "Vanløse", "Nordvest", "Christianshavn"],
    landmarks: ["Karré-ejendomme i hele brokvartererne", "Andels- og ejerforeninger i Indre By", "Erhverv og butikker på Strøget", "Nybyg i Nordhavn og Ørestad"],
    typicalJobs: ["Akut elektriker", "Renovering af lejlighed", "Ladestander i ejerforening", "Tavleudskiftning", "Smart-home og KNX", "Erhvervsservice"],
  },
  {
    slug: "elektriker-frederiksberg",
    city: "Frederiksberg",
    postcode: "2000",
    heroVariant: "split",
    responseMinutes: 75,
    vibe: "Frederiksberg står for klassisk kvalitet, store karréejendomme, villakvarterer og en stærk ejerforeningskultur. Mange opgaver handler om at få moderne installationer ind i smukke, gamle bygninger uden at ødelægge stuk og originale detaljer.",
    housing: "Store karré-ejendomme, herskabelige lejligheder, villaer i Pile Allé-kvarteret og rækkehuse på Frederiksberg C.",
    neighborhoods: ["Frederiksberg C", "Smallegade", "Pile Allé", "Lindevang", "Solbjerg", "Falkoner Allé"],
    landmarks: ["Frederiksberg Have", "Frederiksberg Allé", "Pile Allé villakvarter", "Klassiske karréejendomme"],
    typicalJobs: ["Renovering af klassisk lejlighed", "Tavleudskiftning i ejerforening", "Spots og LED-belysning", "Ladestander", "Fejlfinding", "Smart-home"],
  },
  {
    slug: "elektriker-oesterbro",
    city: "Østerbro",
    postcode: "2100",
    heroVariant: "centered",
    responseMinutes: 45,
    vibe: "Vores hovedkontor ligger på Østersøgade 106A, så Østerbro er vores allernærmeste bagland. Vi kan typisk være ved dig på Østerbro inden for 45 minutter på en hverdag.",
    housing: "Klassiske karré-ejendomme på Strandboulevarden, Trianglen og Indre Østerbro, blandet med nybyg i Nordhavn og småhuse omkring Svanemøllen.",
    neighborhoods: ["Indre Østerbro", "Ydre Østerbro", "Strandboulevarden", "Trianglen", "Svanemøllen", "Ryparken"],
    landmarks: ["Fælledparken", "Parken (stadion)", "Trianglen", "Nordhavn"],
    typicalJobs: ["Akut elektriker", "Renovering i karré-ejendom", "Ladestander i baggård", "Tavleudskiftning", "Belysning", "Erhverv"],
  },
  {
    slug: "elektriker-norrebro",
    city: "Nørrebro",
    postcode: "2200",
    heroVariant: "compact",
    responseMinutes: 60,
    vibe: "Nørrebro er tæt, levende og fyldt med ældre andels- og ejerforeninger. Vi løser mange opgaver i etageejendomme, hvor adgangsforhold, fælles tavler og gamle kabler kræver erfaring og tålmodighed.",
    housing: "Ældre etageejendomme, andelsboliger, baggårdshuse og en del nyere byggeri ved Mimersgade og Nørrebrohallen.",
    neighborhoods: ["Indre Nørrebro", "Nordvest-kanten", "Bispebjerg", "Mjølnerparken", "Mimersgade", "Sankt Hans Torv"],
    landmarks: ["Assistens Kirkegård", "Superkilen", "Nørrebro Bryghus", "Sankt Hans Torv"],
    typicalJobs: ["Akut elektriker", "Andelsforening, fælles installationer", "Tavleudskiftning", "Fejlfinding", "Belysning", "Renovering"],
  },
  {
    slug: "elektriker-nordhavn",
    city: "Nordhavn",
    postcode: "2150",
    heroVariant: "stats",
    responseMinutes: 40,
    accentColor: "oklch(0.72 0.16 130)",
    vibe: "Nordhavn er ren nybyg, moderne karré, lejligheder med store glaspartier og krav til energieffektive installationer. Her handler det mere om smart-home, KNX, ladestandere og solcelleintegration end om aldrende tavler.",
    housing: "Nyt byggeri fra 2010 og frem, høj tæthed, ofte med fælles ladeparker, hybridvarme og avancerede bygningsstyringer.",
    neighborhoods: ["Århusgadekvarteret", "Trælastholmen", "Sundmolen", "Levantkaj", "Orientkaj"],
    landmarks: ["The Silo", "Konditaget Lüders", "Århusgade", "Orientkaj station"],
    typicalJobs: ["Smart-home og KNX", "Ladestander i ejerforening", "Solceller og batteri", "Belysning og scenestyring", "Nybyg el-entreprise", "Erhverv"],
  },
  {
    slug: "elektriker-hellerup",
    city: "Hellerup",
    postcode: "2900",
    heroVariant: "split",
    responseMinutes: 70,
    accentColor: "oklch(0.7 0.12 95)",
    vibe: "Hellerup er villaer, herskabsejendomme og en stærk efterspørgsel efter total løsninger: KNX, alarmsystemer, ladestandere, varmepumper og solceller på samme projekt.",
    housing: "Store enfamilievillaer, klassiske ejendomme på Strandvejen og moderne arkitekttegnede huse i baggadens kvarterer.",
    neighborhoods: ["Strandvejen", "Hellerupvej", "Tuborg Havn", "Maglemosevej", "Onsgårdsvej"],
    landmarks: ["Tuborg Havn", "Hellerup Strand", "Bernstorffsparken (kant)", "Experimentarium"],
    typicalJobs: ["Total el-renovering af villa", "Smart-home og KNX", "Ladestander til to elbiler", "Varmepumpe + solceller", "Belysning og lysdesign", "Fejlfinding"],
  },
  {
    slug: "elektriker-charlottenlund",
    city: "Charlottenlund",
    postcode: "2920",
    heroVariant: "centered",
    responseMinutes: 80,
    vibe: "Charlottenlund er klassiske villakvarterer med god plads, smukke haver og høje krav til finish. Vi laver mange totalløsninger her, hvor el, varme og lys hænger sammen i et fælles styresystem.",
    housing: "Enfamiliehuse fra 1900-1950, arkitekttegnede villaer fra 60'erne-70'erne og nybyggede villaer i tidligere parkbælter.",
    neighborhoods: ["Skovshoved-siden", "Jægersborg Allé", "Hartmannsvej", "Christiansholm", "Ordrup-kanten"],
    landmarks: ["Charlottenlund Slot", "Charlottenlund Fort", "Forstbotanisk Have", "Bellevue Strand"],
    typicalJobs: ["Total el-renovering af villa", "KNX og smart-home", "Lysdesign og spots", "Ladestander", "Varmepumpe", "Fejlfinding"],
  },
  {
    slug: "elektriker-skovshoved",
    city: "Skovshoved",
    postcode: "2920",
    heroVariant: "compact",
    responseMinutes: 80,
    vibe: "Skovshoved er det maritime hjørne af Charlottenlund-området, gamle fiskerhuse, klassiske strandvejsvillaer og et stærkt fokus på arkitektonisk integritet ved enhver renovering.",
    housing: "Små historiske fiskerhuse tæt på havnen, klassiske villaer langs Strandvejen og moderne renoveringer skjult bag bevarede facader.",
    neighborhoods: ["Skovshoved Havn", "Krøyersvej", "Kystvejen", "Strandvejen syd"],
    landmarks: ["Skovshoved Havn", "Skovshoved Hotel", "Strandvejen", "Bellevue"],
    typicalJobs: ["Renovering med bevarede facader", "Ladestander til villa", "Lysdesign", "Smart-home", "Fejlfinding", "Varmepumpe"],
  },
  {
    slug: "elektriker-klampenborg",
    city: "Klampenborg",
    postcode: "2930",
    heroVariant: "split",
    responseMinutes: 90,
    accentColor: "oklch(0.72 0.14 145)",
    vibe: "Klampenborg er natur, klassiske villaer og en stille efterspørgsel efter ekstrem kvalitet. Mange ejendomme her har plads til komplette energiløsninger med solceller, batteri og flere ladestandere.",
    housing: "Klassiske patriciervillaer, arkitekttegnede huse fra mellemkrigstiden og moderne villaer langs Dyrehavevej og Christiansholmsvej.",
    neighborhoods: ["Dyrehavevej", "Christiansholm", "Bellevue", "Sølystvej"],
    landmarks: ["Bakken", "Dyrehaven", "Bellevue Strand", "Klampenborg station"],
    typicalJobs: ["Total energi-løsning (sol + batteri + lade)", "KNX og smart-home", "Lysdesign", "Total el-renovering", "Ladestander", "Alarm og overvågning"],
  },
  {
    slug: "elektriker-vedbaek",
    city: "Vedbæk",
    postcode: "2950",
    heroVariant: "centered",
    responseMinutes: 95,
    vibe: "Vedbæk er kyst, ro og store grunde. Vi kører jævnligt op langs Strandvejen og laver typisk større projekter, hvor el-tavlen, lyset, varmepumpen og ladeboksen er en samlet løsning.",
    housing: "Store villaer fra 1900-tallets begyndelse, parcelhuse fra 60'erne og 70'erne og moderne arkitektvillaer ud mod kysten.",
    neighborhoods: ["Strandvejen Vedbæk", "Trørødvej", "Henriksholm", "Gøngehusvej"],
    landmarks: ["Vedbæk Havn", "Henriksholm Skov", "Trørød By", "Vedbæk Strand"],
    typicalJobs: ["Total villa-renovering", "Ladestander til flere elbiler", "Varmepumpe", "Solceller og batteri", "Smart-home", "Lysdesign"],
  },
  {
    slug: "elektriker-soborg",
    city: "Søborg",
    postcode: "2860",
    heroVariant: "stats",
    responseMinutes: 65,
    vibe: "Søborg er en blanding af parcelhuse, rækkehuse og etagebyggeri, og en god del erhverv langs Gladsaxe Møllevej. Vi har faste kunder her blandt både private og virksomheder.",
    housing: "Parcelhuse fra 50'erne-70'erne, rækkehuse, kæmpe etageejendomme og industri/erhverv langs Mørkhøjvej og Gladsaxe Møllevej.",
    neighborhoods: ["Søborg Hovedgade", "Buddinge", "Mørkhøj", "Maglegårds Allé"],
    landmarks: ["Søborg Torv", "Gladsaxe Sportscenter", "Buddinge station", "Gladsaxe Møllevej erhverv"],
    typicalJobs: ["Akut elektriker", "Renovering af parcelhus", "Erhvervsservice", "Tavleudskiftning", "Ladestander", "Belysning"],
  },
  {
    slug: "elektriker-gladsaxe",
    city: "Gladsaxe",
    postcode: "2860",
    heroVariant: "compact",
    responseMinutes: 65,
    vibe: "Gladsaxe er en af de tætteste erhvervskommuner i Storkøbenhavn, vi laver alt fra service på lagre og kontorer til private parcelhus-opgaver i Bagsværd, Buddinge og Mørkhøj.",
    housing: "Stort industri/erhvervsområde, blandet med parcelhuse, rækkehuse og almene boliger.",
    neighborhoods: ["Gladsaxe Trafikplads", "Mørkhøj", "Bagsværd-kanten", "Buddinge"],
    landmarks: ["Gladsaxe Trafikplads", "Telia-bygningen", "Gladsaxe Rådhus", "Bagsværd Sø"],
    typicalJobs: ["Erhvervsservice", "Industri-el", "Tavleudskiftning", "Akut elektriker", "Ladestander til flåde", "Belysning"],
  },
  {
    slug: "elektriker-vanloese",
    city: "Vanløse",
    postcode: "2720",
    heroVariant: "split",
    responseMinutes: 60,
    vibe: "Vanløse er familievenlige kvarterer, rækkehuse og 30'er-villaer. Mange opgaver her er renoveringer i forbindelse med flyt eller børnefamilier der opgraderer huset.",
    housing: "Rækkehuse, klassiske 30'er-villaer, etageejendomme omkring Vanløse station og nybyg ved Grøndalsparken.",
    neighborhoods: ["Vanløse Allé", "Jernbane Allé", "Grøndal", "Vanløse Torv"],
    landmarks: ["Vanløse station", "Grøndalsparken", "Damhussøen (kant)", "Vanløse Torv"],
    typicalJobs: ["Renovering af villa", "Tavleudskiftning", "Ladestander", "Belysning", "Akut elektriker", "Smart-home"],
  },
  {
    slug: "elektriker-valby",
    city: "Valby",
    postcode: "2500",
    heroVariant: "centered",
    responseMinutes: 65,
    vibe: "Valby er et bredt sammensat område: gamle etageejendomme i Gammel Valby, store nybyggerier i Grønttorvet-området og parcelhuse i Vigerslev. Vi har faste kunder i hele området.",
    housing: "Klassiske etageejendomme i Gammel Valby, parcelhuse i Vigerslev, store nybyggerier i Grønttorvet og industri ved Carlsberg-grunden.",
    neighborhoods: ["Gammel Valby", "Valby Langgade", "Vigerslev", "Grønttorvet", "Toftegårds Plads"],
    landmarks: ["Spinderiet", "Valby Station", "Grønttorvet", "Vigerslev Allé"],
    typicalJobs: ["Renovering", "Ladestander i ejerforening", "Tavleudskiftning", "Erhverv", "Akut elektriker", "Belysning"],
  },
  {
    slug: "elektriker-dragoer",
    city: "Dragør",
    postcode: "2791",
    heroVariant: "compact",
    responseMinutes: 95,
    vibe: "Dragør er bevaringsværdige gamle huse, havnemiljø og en stærk lokal stolthed. Renoveringer her kræver respekt for både fredning og det maritime klima, kabler skal kunne tåle salt og fugt.",
    housing: "Fredede og bevaringsværdige bindingsværkshuse i Gamle Dragør, parcelhuse i Søvang og rækkehuse omkring Hollænderhallen.",
    neighborhoods: ["Gamle Dragør", "Søvang", "St. Magleby", "Hollænderhallen"],
    landmarks: ["Dragør Havn", "Dragør Gamle By", "Kongelundsfortet", "Dragør Strand"],
    typicalJobs: ["Renovering i bevaringsværdig ejendom", "Saltbestandige installationer", "Ladestander", "Tavleudskiftning", "Belysning", "Akut elektriker"],
  },
  {
    slug: "elektriker-skovlunde",
    city: "Skovlunde",
    postcode: "2740",
    heroVariant: "stats",
    responseMinutes: 75,
    vibe: "Skovlunde er klassiske parcelhuskvarterer, almene boliger og et godt lokalt handelsliv. Vi kommer her dagligt for både private og foreninger.",
    housing: "Parcelhuse fra 50'erne-70'erne, almene boligforeninger og rækkehuse omkring Skovlunde Center.",
    neighborhoods: ["Skovlunde Center", "Bybjergvej", "Harrestrup Å-kanten", "Ballerup-kanten"],
    landmarks: ["Skovlunde Center", "Skovlunde station", "Harrestrup Å", "Skovlunde Idrætspark"],
    typicalJobs: ["Renovering af parcelhus", "Almen bolig, fællesinstallationer", "Tavleudskiftning", "Ladestander", "Akut elektriker", "Belysning"],
  },
  {
    slug: "elektriker-nordsjaelland",
    city: "Nordsjælland",
    heroVariant: "stats",
    responseMinutes: 120,
    accentColor: "oklch(0.7 0.14 145)",
    vibe: "Nordsjælland dækker for os Rungsted, Hørsholm, Holte, Birkerød, Lyngby og hele strandvejs-strækningen. Vi kører her primært på større, planlagte opgaver, typisk villa-renoveringer og totalløsninger med varme, sol og lade.",
    housing: "Store villaer, sommerhuse omkring kysten og klassiske patriciervillaer langs Strandvejen.",
    neighborhoods: ["Rungsted", "Hørsholm", "Holte", "Birkerød", "Lyngby", "Skodsborg"],
    landmarks: ["Strandvejen", "Rungsted Havn", "Hørsholm Bymidte", "Furesøen"],
    typicalJobs: ["Total villa-renovering", "Solceller + batteri + lade", "KNX og smart-home", "Varmepumpe", "Lysdesign", "Alarm"],
  },
  {
    slug: "elektriker-indre-by",
    city: "Indre By",
    postcode: "1000",
    heroVariant: "split",
    responseMinutes: 50,
    vibe: "Indre By er Københavns ældste bygningsmasse, fredninger, smalle trapper, små lejligheder og baggårde med begrænset adgang. Det stiller særlige krav til en elektriker, og det er vi vant til.",
    housing: "Fredede og bevaringsværdige ejendomme fra 1700-1800-tallet, butiks- og restaurantlokaler i stueplan og kontorer i etagerne.",
    neighborhoods: ["Strøget", "Christianshavn", "Latinerkvarteret", "Gammelholm", "Vesterport", "Frederiksstaden"],
    landmarks: ["Strøget", "Nyhavn", "Kongens Nytorv", "Rundetårn", "Christianshavn Kanal"],
    typicalJobs: ["Renovering i fredede ejendomme", "Butiks- og restaurantinstallationer", "Akut elektriker", "Tavleudskiftning", "Erhvervsservice", "Belysning"],
  },
  {
    slug: "elektriker-amager",
    city: "Amager",
    postcode: "2300",
    heroVariant: "centered",
    responseMinutes: 55,
    vibe: "Amager er enormt varieret, gamle Sundby-ejendomme, parcelhuse i Tårnby, nybyg i Ørestad og industri ved Amager Strand. Vi kører på hele øen hver eneste dag.",
    housing: "Etageejendomme i Sundby, rækkehuse og parcelhuse på resten af øen, og store moderne komplekser i Ørestad og ved Amager Strand.",
    neighborhoods: ["Amagerbro", "Sundby", "Ørestad", "Tårnby", "Kastrup-kanten", "Islands Brygge"],
    landmarks: ["Amager Strand", "Field's", "Bella Center", "Ørestad", "Islands Brygge havnebad"],
    typicalJobs: ["Akut elektriker", "Renovering", "Ladestander", "Smart-home i Ørestad-nybyg", "Tavleudskiftning", "Erhverv"],
  },
  {
    slug: "elektriker-sydhavn",
    city: "Sydhavn",
    postcode: "2450",
    heroVariant: "compact",
    responseMinutes: 60,
    vibe: "Sydhavn er en spændende blanding af gammel arbejderkultur, ny boligudvikling på Teglholmen og Enghave Brygge, og et stort erhvervsbælte. Vi laver mange forskellige opgavetyper her.",
    housing: "Klassiske etageejendomme i Gammel Sydhavn, moderne lejligheder på Teglholmen og Enghave Brygge, og industri/erhverv langs jernbanen.",
    neighborhoods: ["Sydhavn", "Teglholmen", "Enghave Brygge", "Sluseholmen", "Mozarts Plads"],
    landmarks: ["Teglholmen", "Sluseholmen", "Karens Minde", "Mozarts Plads"],
    typicalJobs: ["Renovering i nybyg", "Akut elektriker", "Erhverv", "Tavleudskiftning", "Ladestander", "Smart-home"],
  },
  {
    slug: "elektriker-bagsvaerd",
    city: "Bagsværd",
    postcode: "2880",
    heroVariant: "split",
    responseMinutes: 75,
    vibe: "Bagsværd er villakvarterer, en hyggelig hovedgade og en god del erhverv ved søen og motorvejen. Vi laver alt fra parcelhus-renoveringer til service på kontor- og lagerlejemål.",
    housing: "Parcelhuse, rækkehuse omkring Bagsværd Sø og erhverv ved Bagsværd Møllevej og Aldershvilevej.",
    neighborhoods: ["Bagsværd Hovedgade", "Bagsværd Sø", "Aldershvile", "Værebrovej"],
    landmarks: ["Bagsværd Sø", "Bagsværd Roklub", "Bagsværd Kirke", "Aldershvile Slotspark"],
    typicalJobs: ["Renovering af villa", "Erhvervsservice", "Tavleudskiftning", "Ladestander", "Akut elektriker", "Belysning"],
  },
  {
    slug: "elektriker-herlev",
    city: "Herlev",
    postcode: "2730",
    heroVariant: "stats",
    responseMinutes: 70,
    vibe: "Herlev er klassisk forstad med både privat- og erhvervskunder. Vi har faste samarbejder med flere foreninger og laver mange tavle- og ladestander-opgaver her.",
    housing: "Parcelhuse, rækkehuse, store almene boligforeninger og erhverv langs Ring 3 og Herlev Hovedgade.",
    neighborhoods: ["Herlev Hovedgade", "Hjortespringvej", "Kagsåkollegiet", "Marielundvej"],
    landmarks: ["Herlev Hospital", "Herlev Bymidte", "Hjortespringbadet", "Kagsåparken"],
    typicalJobs: ["Tavleudskiftning", "Almene boliger, fællesinstallationer", "Ladestander til carport", "Erhvervsservice", "Akut elektriker", "Belysning"],
  },
  {
    slug: "elektriker-kastrup",
    city: "Kastrup",
    postcode: "2770",
    heroVariant: "stats",
    responseMinutes: 70,
    vibe: "Kastrup er parcelhuse, rækkehuse og et stort erhvervsbælte ved lufthavnen. Vi servicerer både private og virksomheder i området, og er vant til høje kvalitetskrav fra erhverv tæt på CPH.",
    housing: "Parcelhuse, rækkehuse, klassiske etageejendomme i Kastrupvej-området og et stort moderne erhvervsområde ved lufthavnen.",
    neighborhoods: ["Kastrupvej", "Skottegården", "Tårnby Torv", "Ved Diget", "Lufthavnskvarteret"],
    landmarks: ["Københavns Lufthavn", "Kastrup Strandpark", "Kastruplundgade", "Tårnby Torv"],
    typicalJobs: ["Erhvervsservice nær lufthavn", "Akut elektriker", "Renovering", "Tavleudskiftning", "Ladestander", "Belysning"],
  },
  {
    slug: "elektriker-nordvest",
    city: "Nordvest",
    postcode: "2400",
    heroVariant: "compact",
    responseMinutes: 55,
    vibe: "Nordvest er i hastig udvikling, klassiske industriejendomme bliver omdannet til boliger, og kvarteret omkring Bispebjerg og Bellahøj har en god blanding af gamle og helt nye installationer.",
    housing: "Klassiske etageejendomme, almene boligområder (bl.a. Bellahøj), industrilofts under omdannelse og nybyg ved Lygten.",
    neighborhoods: ["Bispebjerg", "Bellahøj", "Lygten", "Frederikssundsvej", "Rentemestervej"],
    landmarks: ["Bispebjerg Hospital", "Bellahøj-husene", "Grundtvigs Kirke", "Lygten Station"],
    typicalJobs: ["Renovering af industriloft", "Almen bolig, fællesinstallationer", "Akut elektriker", "Tavleudskiftning", "Ladestander", "Belysning"],
  },
  {
    slug: "elektriker-vesterbro",
    city: "Vesterbro",
    postcode: "1700",
    heroVariant: "centered",
    responseMinutes: 50,
    vibe: "Vesterbro er klassiske brokvarters-karréer, tæt byliv og en hastig blanding af gamle andelsforeninger og nyrenoverede ejerlejligheder. Mange opgaver handler om at modernisere gamle installationer uden at røre stuk og originale fag.",
    housing: "Klassiske karréejendomme fra slutningen af 1800-tallet, ombyggede slagteriejendomme i Kødbyen og nybyg ved Carlsberg Byen.",
    neighborhoods: ["Indre Vesterbro", "Kødbyen", "Carlsberg Byen", "Enghave", "Sønder Boulevard"],
    landmarks: ["Kødbyen", "Carlsberg Byen", "Enghaveparken", "Tivoli (kant)"],
    typicalJobs: ["Akut elektriker", "Renovering af karré-ejendom", "Tavleudskiftning", "Ladestander i baggård", "Belysning", "Erhvervsservice i Kødbyen"],
  },
  {
    slug: "elektriker-christianshavn",
    city: "Christianshavn",
    postcode: "1400",
    heroVariant: "compact",
    responseMinutes: 50,
    vibe: "Christianshavn er kanaler, fredede ejendomme og højt arkitektonisk krav. Vi laver ofte el-arbejde, hvor synlige rør og originale detaljer skal bevares samtidig med moderne sikkerhed og energikrav.",
    housing: "Fredede pakhuse, klassiske karréejendomme, husbåde og moderne nybyg på Krøyers Plads og Papirøen.",
    neighborhoods: ["Christianshavns Torv", "Holmen", "Papirøen", "Krøyers Plads", "Wilders Plads"],
    landmarks: ["Vor Frelsers Kirke", "Christiania", "Operaen", "Inderhavnsbroen"],
    typicalJobs: ["Renovering i fredet ejendom", "Akut elektriker", "Smart-home", "Tavleudskiftning", "Belysning", "Ladestander"],
  },
  {
    slug: "elektriker-lyngby",
    city: "Lyngby",
    postcode: "2800",
    heroVariant: "split",
    responseMinutes: 75,
    vibe: "Lyngby er bymidte, store erhvervsejendomme og villakvarterer i ét. Vi servicerer både butikker i Lyngby Storcenter-området, kontorer og private villaer i Sorgenfri og Virum-kanten.",
    housing: "Klassiske villaer, rækkehuse, almene boligforeninger og et stort erhvervsbælte omkring Lyngby Hovedgade og Firskovvej.",
    neighborhoods: ["Lyngby Hovedgade", "Sorgenfri", "Lundtofte", "Virum-kanten", "Firskovvej"],
    landmarks: ["Lyngby Storcenter", "DTU", "Sorgenfri Slot", "Lyngby Sø"],
    typicalJobs: ["Erhvervsservice", "Total villa-renovering", "Ladestander", "Tavleudskiftning", "Smart-home", "Fejlfinding"],
  },
  {
    slug: "elektriker-virum",
    city: "Virum",
    postcode: "2830",
    heroVariant: "centered",
    responseMinutes: 80,
    vibe: "Virum er stille parcelhuskvarterer, store grunde og familieboliger fra 50'erne-70'erne. Mange opgaver er total el-renoveringer, hvor vi opdaterer både tavle, gruppefordeling og belysning på én gang.",
    housing: "Parcelhuse fra efterkrigstiden, arkitekttegnede villaer og enkelte rækkehus-projekter i kanten af Lyngby.",
    neighborhoods: ["Virum Stationsvej", "Geels Bakke", "Frederiksdal", "Kongevejen"],
    landmarks: ["Frederiksdal", "Furesøen", "Virum Skole", "Geels Skov"],
    typicalJobs: ["Total el-renovering af villa", "Tavleudskiftning", "Ladestander", "Varmepumpe", "Belysning", "Smart-home"],
  },
  {
    slug: "elektriker-holte",
    city: "Holte",
    postcode: "2840",
    heroVariant: "split",
    responseMinutes: 85,
    vibe: "Holte er store villaer, søer og skov. Vi laver mange totalløsninger her med ladeboks, varmepumpe og smart-home i samme projekt, ofte for familier med høje krav til finish og driftsikkerhed.",
    housing: "Store enfamilievillaer, arkitekttegnede huse fra 60'erne-70'erne og moderne nybyggede villaer på store grunde.",
    neighborhoods: ["Holte Stationsvej", "Søllerødvej", "Vejlesøvej", "Rudegårds Allé"],
    landmarks: ["Vejlesø", "Søllerød Kirke", "Rudegård", "Mothsgården"],
    typicalJobs: ["Total villa-renovering", "Ladestander til flere elbiler", "Varmepumpe", "KNX og smart-home", "Lysdesign", "Solceller"],
  },
  {
    slug: "elektriker-gentofte",
    city: "Gentofte",
    postcode: "2820",
    heroVariant: "stats",
    responseMinutes: 70,
    vibe: "Gentofte er klassiske villakvarterer, høj boligstandard og en stærk efterspørgsel efter totalløsninger. Vi laver ofte el-renoveringer hvor tavle, lys, varme og ladeboks tænkes sammen fra start.",
    housing: "Store villaer fra 1900-1950, arkitektvillaer fra mellemkrigstiden og nybyggede villaer i Bernstorff-kvarteret.",
    neighborhoods: ["Bernstorff", "Vangede", "Dyssegård", "Jægersborg", "Gentoftegade"],
    landmarks: ["Bernstorffsparken", "Gentofte Sø", "Gentofte Hospital", "Jægersborg Allé"],
    typicalJobs: ["Total el-renovering af villa", "KNX og smart-home", "Ladestander", "Varmepumpe", "Lysdesign", "Fejlfinding"],
  },
  {
    slug: "elektriker-hoersholm",
    city: "Hørsholm",
    postcode: "2970",
    heroVariant: "split",
    responseMinutes: 95,
    vibe: "Hørsholm er villaer, parker og en velhavende kunde-profil. Vi kører jævnligt op langs Kongevejen og laver typisk store, samlede el-, varme- og lade-løsninger for familier i området.",
    housing: "Store villaer, parcelhuse fra 60'erne-70'erne, klassiske patriciervillaer ved Rungstedvej og moderne nybyg i Usserød-kanten.",
    neighborhoods: ["Hørsholm Torv", "Rungstedvej", "Usserød", "Kokkedal-kanten"],
    landmarks: ["Hørsholm Slotspark", "Rungstedlund", "Folehavevej", "Hørsholm Midtpunkt"],
    typicalJobs: ["Total villa-renovering", "Ladestander", "Varmepumpe + solceller", "Smart-home", "Lysdesign", "Alarm"],
  },
  {
    slug: "elektriker-broenshoej",
    city: "Brønshøj",
    postcode: "2700",
    heroVariant: "compact",
    responseMinutes: 60,
    vibe: "Brønshøj er parcelhuse, rækkehuse og rolige villaveje med god kombination af ældre installationer og familier der vil have det moderniseret. Vi laver mange tavleudskiftninger og ladeboks-opgaver her.",
    housing: "Parcelhuse fra 30'erne-60'erne, rækkehuse, almene boligforeninger og enkelte etageejendomme langs Frederikssundsvej.",
    neighborhoods: ["Brønshøj Torv", "Husum-kanten", "Tingbjerg", "Frederikssundsvej"],
    landmarks: ["Brønshøj Vandtårn", "Brønshøj Kirke", "Tingbjerg", "Utterslev Mose"],
    typicalJobs: ["Tavleudskiftning", "Renovering af parcelhus", "Ladestander til carport", "Fejlfinding", "Belysning", "Almene boliger"],
  },
  {
    slug: "elektriker-roedovre",
    city: "Rødovre",
    postcode: "2610",
    heroVariant: "stats",
    responseMinutes: 65,
    vibe: "Rødovre er parcelhuse, rækkehuse og et stort erhvervsbælte langs Roskildevej. Vi servicerer både private og virksomheder her og laver mange erhvervsopgaver med servicekontrakter.",
    housing: "Parcelhuse fra 50'erne-70'erne, almene boligforeninger og et stort erhvervsområde langs Roskildevej og Islevdalvej.",
    neighborhoods: ["Rødovre Centrum", "Islev", "Hvidsværmervej", "Roskildevej"],
    landmarks: ["Rødovre Centrum", "Heerup Museum", "Vestvolden", "Damhussøen"],
    typicalJobs: ["Erhvervsservice", "Tavleudskiftning", "Renovering af parcelhus", "Ladestander", "Akut elektriker", "Belysning"],
  },
  {
    slug: "elektriker-hvidovre",
    city: "Hvidovre",
    postcode: "2650",
    heroVariant: "compact",
    responseMinutes: 70,
    vibe: "Hvidovre er klassisk forstad med store almene boligområder, parcelhuse og en del erhverv. Vi har faste samarbejder med flere foreninger og laver mange fællesinstallationer her.",
    housing: "Store almene boligområder (Avedøre Stationsby), parcelhuse, rækkehuse og industri/erhverv mod Avedøre Holme.",
    neighborhoods: ["Hvidovrevej", "Avedøre Stationsby", "Friheden", "Avedøre Holme"],
    landmarks: ["Hvidovre Hospital", "Avedøre Stationsby", "Friheden Station", "Quark Centret"],
    typicalJobs: ["Almene boliger, fællesinstallationer", "Tavleudskiftning", "Erhvervsservice", "Akut elektriker", "Ladestander", "Belysning"],
  },
  {
    slug: "elektriker-ballerup",
    city: "Ballerup",
    postcode: "2750",
    heroVariant: "stats",
    responseMinutes: 80,
    vibe: "Ballerup er stort erhverv, store kontorhuse, datacentre og et bredt parcelhus-bælte. Vi laver mange servicekontrakter med virksomheder her og opgaver i de mange foreninger.",
    housing: "Parcelhuse, rækkehuse, almene boligområder og et meget stort erhvervsbælte mod Lautrupgård og Borupvang.",
    neighborhoods: ["Ballerup Centrum", "Lautrupgård", "Skovlunde-kanten", "Måløv", "Egebjerg"],
    landmarks: ["Ballerup Super Arena", "Lautrupgård Erhvervspark", "Måløv Naturpark", "Pederstrupvej"],
    typicalJobs: ["Erhvervsservice og servicekontrakt", "Tavleudskiftning", "Ladestander til flådebiler", "Belysning", "Akut elektriker", "Smart-home"],
  },
  {
    slug: "elektriker-birkeroed",
    city: "Birkerød",
    postcode: "3460",
    heroVariant: "centered",
    responseMinutes: 90,
    vibe: "Birkerød er villaer, skov og en stille familievenlig profil. Vi laver mange totalløsninger med ladeboks og varmepumpe, ofte koblet sammen med solceller for at få driftsomkostningerne ned.",
    housing: "Parcelhuse fra 60'erne-70'erne, klassiske villaer, rækkehuse og enkelte moderne nybyggerier i Bistrup og Høsterkøb-kanten.",
    neighborhoods: ["Birkerød Hovedgade", "Bistrup", "Høsterkøb-kanten", "Sjælsø"],
    landmarks: ["Sjælsø", "Birkerød Sø", "Bistrupskolen", "Birkerød Idrætscenter"],
    typicalJobs: ["Total villa-renovering", "Varmepumpe + solceller", "Ladestander", "Tavleudskiftning", "Smart-home", "Lysdesign"],
  },
  {
    slug: "elektriker-greve",
    city: "Greve",
    postcode: "2670",
    heroVariant: "split",
    responseMinutes: 90,
    introLead:
      "Autoriseret elektriker i Greve og resten af Køge Bugt. Vi løser akutte el-fejl, planlagte installationer, ladestandere, varmepumper og total el-renovering for private, foreninger og erhverv i Greve, Hundige, Karlslunde og Tune, med fast pris, dokumentation og garanti.",
    vibe: "Greve er en klassisk forstadskommune ved Køge Bugt med tætte parcelhuskvarterer, rækkehusbebyggelser og et stærkt erhvervsområde langs Greve Main. Vi kører dagligt på Køge Bugt-strækningen og kender både de store parcelhusudstykninger fra 60'erne og 70'erne og de nyere boligområder tæt på stranden.",
    housing: "Overvejende parcelhuse og rækkehuse fra 1960'erne til 1980'erne, større almene bebyggelser omkring Hundige og Askerød, sommerhusprægede villaer nær Greve Strand samt et betydeligt erhvervs- og lagerområde ved Greve Main og Ventrupparken.",
    neighborhoods: ["Greve Strand", "Hundige", "Karlslunde", "Tune", "Mosede", "Greve Landsby", "Askerød", "Ventrupparken", "Greve Main", "Kildebrønde"],
    landmarks: ["Waves Shoppingcenter i Hundige", "Greve Strandpark", "Greve Main erhvervsområde", "Mosede Fort", "Portalen i Greve"],
    typicalJobs: ["Akut elektriker", "Ladestander til elbil", "Varmepumpe og solceller", "Tavleudskiftning", "Erhvervsservice på Greve Main", "El-tjek og fejlfinding"],
  },
];

export const LOCATION_MAP: Record<string, LocationData> = Object.fromEntries(
  LOCATIONS.map((l) => [l.slug, l]),
);
